<template>
  <div class="wrapper">
    <h3 class="title">中升二手车业务数据</h3>
    <form class="form-group" ref="loginForm">
      <div class="item">
        <input type="tel"
               name="phone"
               maxlength="11"
               placeholder="手机号码"
               v-model="formData.phone"
               v-blur-validate:textRed="['required', 'validatePhone']"
        >
      </div>
      <div class="item item-picture">
        <input type="text"
               name="picCode"
               placeholder="图形验证码"
               v-model="formData.picCode"
               v-blur-validate:textRed="['required']"
        >
        <img alt="验证码" class="very-pic" :src="veryPic" @click="getPicCode"/>
      </div>
      <div class="item item-code">
        <input type="number"
               name="smsCode"
               placeholder="短信验证码"
               v-model="formData.smsCode"
               v-blur-validate:textRed="['required']"
        >
        <button :class="['get-code', {'count-down': canGetMsm}]" @click.prevent="getMsmCode">{{countText}}</button>
      </div>
    </form>
    <button class="login-btn" v-check-submit:loginForm="login">登录</button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        formData: {
          phone: '',
          picCode: '',
          smsCode: ''
        },
        veryPic: '',
        count: 60,
        canGetMsm: true
      }
    },
    computed: {
      countText() {
        if (this.canGetMsm) {
          return '获取验证码'
        } else {
          return `${this.count}s`
        }
      }
    },
    created() {
      this.$rest.personal.checkAuth()
        .then(res => {
          if (res.code === 0 && res.data.is_authenticated) {
            if (res.data.is_authenticated) {
              this.$router.push({ path: 'calendar' })
            }
          }
        })
      this.getPicCode()
    },
    methods: {
      // 获取图形验证码
      getPicCode() {
        this.veryPic = `/auth/captcha?${Math.random()}`
        this.formData.picCode = ''
      },
      judgeMsm() {
        const { phone, picCode } = this.formData
        return phone && /^1\d{10}$/.test(phone) && picCode
      },
      getMsmCode() {
        if (this.judgeMsm) {
          this.$rest.personal.getMsmCode(this.formData)
            .then(res => {
              if (res.code === 0) {
                this.canGetMsm = false
                // 短信倒计时
                this.timer = setInterval(() => {
                  if (this.count > 1) {
                    this.count--
                  } else {
                    this.count = 60
                    this.canGetMsm = true
                    clearInterval(this.timer)
                  }
                }, 1000)
              }
            })
        }
      },
      login() {
        this.$rest.personal.login(this.formData)
          .then(res => {
            if (res.code === 0) {
              // 将登录者的信息存到本地存储中
              localStorage.removeItem('userInfo')
              localStorage.setItem('userInfo', JSON.stringify(res.data))
              this.$router.push({ path: 'calendar' })
            }
          })
      }
    },
    beforeDestroy() {
      this.timer && clearInterval(this.timer)
    }
  }
</script>

<style scoped lang="less">
  .wrapper {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    padding-bottom: 1.5rem;
    width: 100%;
    height: 100vh;
    background: #cedff0 url(../../../assets/styles/images/login-bg.png) no-repeat;
    background-size: contain;

    .title {
      width: 4.8rem;
      height: 0.7rem;
      margin-bottom: .4rem;
      font-size: 0.5rem;
      font-weight: bold;
      color: #3a4554;
    }

    .form-group {
      width: 9.1rem;
      padding: 0 .3rem;
      margin-bottom: .8rem;
      border-radius: 0.1rem;
      background-color: #ffffff;
      box-shadow: 0 0 0 0 rgba(45, 45, 45, 0.06);

      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.4rem;

        input {
          flex: 1;
          font-size: 0.4rem;
          margin-left: .1rem;
          line-height: .7rem;
          border: none;
          outline: none;
        }
      }
      .check-error {
        input {
          color: #e95552;
        }
        ::-moz-placeholder {
          color: #e95552;
        }
        ::-webkit-input-placeholder {
          color: #e95552;
        }
        :-ms-input-placeholder {
          color: #e95552;
        }
      }

      .item-picture {
        border-top: 1px solid #bec2cf;
        border-bottom: 1px solid #bec2cf;
        box-shadow: 0 0 0 0 rgba(45, 45, 45, 0.06);

        .very-pic {
          width: 1.6rem;
          height: 0.7rem;
          margin-right: .1rem;
        }
      }

      .item-code {
        .get-code {
          /*width: 2.4rem;*/
          height: 0.8rem;
          padding: 0 .3rem;
          margin-right: .1rem;
          background-color: #ffffff;
          border-radius: 0.1rem;
          border: solid 1px rgba(0, 0, 0, 0.1);
        }

        .count-down {
          color: #666;
        }
      }
    }

    .login-btn {
      width: 9.1rem;
      height: 1.3rem;
      font-size: 0.5rem;
      color: #ffffff;
      background-image: linear-gradient(90deg, #1ba2fc 0%, #1967fb 100%);
      box-shadow: 0 0 0.2rem 0 rgba(21, 161, 255, 0.5);
      border-radius: 0.1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?2a587cfc